"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var react_1 = require("react");
var FlagIcon_1 = __importDefault(require("./FlagIcon"));
var CountrySelector = (0, react_1.forwardRef)(function (_a, ref) {
    var selectedCountry = _a.selectedCountry, _b = _a.enableCountryChange, enableCountryChange = _b === void 0 ? false : _b, _c = _a.isCountryMenuOpen, isCountryMenuOpen = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, onClick = _a.onClick, onKeyDown = _a.onKeyDown;
    // If disabled, we should not allow country changes
    var isInteractive = enableCountryChange && !disabled;
    return ((0, jsx_runtime_1.jsxs)("div", { ref: ref, className: "country-selector", onClick: isInteractive ? onClick : undefined, style: {
            display: 'flex',
            alignItems: 'center',
            cursor: isInteractive ? 'pointer' : 'default',
            minWidth: '40px',
            justifyContent: 'center',
            opacity: disabled ? 0.6 : 1,
        }, role: isInteractive ? 'button' : undefined, tabIndex: isInteractive ? 0 : undefined, "aria-label": isInteractive
            ? "Select country, currently ".concat(selectedCountry.name)
            : "Country: ".concat(selectedCountry.name), "aria-haspopup": isInteractive ? 'listbox' : undefined, "aria-expanded": isInteractive ? isCountryMenuOpen : undefined, "aria-controls": isInteractive ? 'country-selector-listbox' : undefined, onKeyDown: isInteractive ? onKeyDown : undefined, children: [(0, jsx_runtime_1.jsx)(FlagIcon_1.default, { countryCode: selectedCountry.code }), isInteractive && ((0, jsx_runtime_1.jsx)(ExpandMore_1.default, { style: {
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 1)',
                    marginLeft: '4px',
                    transform: isCountryMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.1s ease-in-out',
                } }))] }));
});
CountrySelector.displayName = 'CountrySelector';
exports.default = CountrySelector;
//# sourceMappingURL=CountrySelector.js.map